import {
  WSActions,
  WSElement,
  WSPanel,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { useRef, useState } from "react";
import {
  FormInvoicingConfig,
  FormInvoicingConfigRef
} from "../../components/FormInvoicingConfig";
import { usePayrollSettingsProgress } from "../../hooks/usePayrollSettingsProgress";

import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const PayablesSettings: React.FC<FlowStep> = ({
  title,
  onBack,
  onNext
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const invoicingConfigFormRef = useRef<FormInvoicingConfigRef>(null);
  const { markPayablesSettingsSaved } = usePayrollSettingsProgress();

  // Marking the step saved completes the module, which is what moves the flow on
  // to the result screen — see usePayrollSettingsProgress and FlowSwitch.
  const handleSaveSuccess = () => {
    markPayablesSettingsSaved();
    onNext?.();
  };
  return (
    <>
      <WSPanel mb="2XL">
        <WSElement mb="2XL">
          <WSSectionToolbar title={title} />
          <WSText.ParagraphSm color="gray500">
            Configure what inputs can be edited on payables (invoices)
          </WSText.ParagraphSm>
        </WSElement>

        <FormInvoicingConfig
          ref={invoicingConfigFormRef}
          setLoading={setLoading}
          hideSaveButton
          onSaveSuccess={handleSaveSuccess}
        />
      </WSPanel>

      <WSActions
        mb="2XL"
        alignment="fill"
        buttons={[
          {
            onClick: onBack,
            kind: "Secondary",
            label: "Back",
            visible: !!onBack
          },
          {
            loading,
            onClick: () => {
              invoicingConfigFormRef.current?.requestSubmit();
            },
            label: "Save & continue"
          }
        ]}
      />
      <WSText.ParagraphXs weight="book" color="gray400">
        Payroll settings (payroll schedule and payables settings) can be viewed
        and updated at any time in your settings.
      </WSText.ParagraphXs>
    </>
  );
};
